module.exports = __webpack_public_path__ + "static/media/Partner3.f5563925.webp";